module.exports = __webpack_public_path__ + "media/4.25be83a2.mp3";